import React from 'react';
import './SsembleBanner.css';

// Thin promo strip above the homepage that points visitors to Ssemble.
// Kept as a plain promo (no "shutting down" wording) so the Shorts Creator page
// still reads as a working app to platform reviewers.
const SIGNUP_URL =
  'https://app.ssemble.com/signup?utm_source=shortscreator&utm_medium=referral&utm_campaign=shortscreator_promo_bar';

export default function SsembleBanner() {
  return (
    <a className="ssb-bar" href={SIGNUP_URL} target="_blank" rel="noopener noreferrer">
      <span className="ssb-tag">New</span>
      <span className="ssb-text">
        Try <strong>Ssemble</strong>: turn long videos into viral shorts with AI
      </span>
      <span className="ssb-cta">
        Get started <span aria-hidden="true">→</span>
      </span>
    </a>
  );
}
